import Loadable from 'react-loadable';
import Loading from 'views/widgets/loading';
import NavigationPanel from 'views/panels/navigation/base';
import ContentAuth from 'views/panels/content-auth';

const HeaderVerintTop = Loadable({
  loader: () => import('views/panels/header-verintTop'),
  loading: Loading,
});
HeaderVerintTop.preload();

const NavUnified = Loadable({
  loader: () => import('views/panels/nav-unified'),
  loading: Loading,
});
NavUnified.preload();

const HeaderSiteNav = Loadable({
  loader: () => import('views/panels/header-site-nav'),
  loading: Loading,
});
HeaderSiteNav.preload();

const ContentError = Loadable({
  loader: () => import('views/panels/content-error'),
  loading: Loading,
});
ContentError.preload();

const SidebarProjectDnd = Loadable({
  loader: () => import('views/panels/sidebar-project-dnd'),
  loading: Loading,
});
SidebarProjectDnd.preload();

const ChartPanel = Loadable({
  loader: () => import('views/panels/content-chart-panel'),
  loading: Loading,
});
ChartPanel.preload();

const DashboardFilters = Loadable({
  loader: () => import('views/panels/dashboards/subnav-filter-dashboards'),
  loading: Loading,
});
DashboardFilters.preload();

const ContentHierarchy = Loadable({
  loader: () => import('views/panels/settings/setup/general/content-hierarchy'),
  loading: Loading,
});
ContentHierarchy.preload();

const ContentSettings2HierarchyNew = Loadable({
  loader: () => import('views/panels/settings/setup/hierarchy/new'),
  loading: Loading,
});
ContentSettings2HierarchyNew.preload();

const ContentHierarchyDetails = Loadable({
  loader: () => import('views/panels/settings/setup/hierarchy/details'),
  loading: Loading,
});
ContentHierarchyDetails.preload();

const ContentHierarchyVersionsDetail = Loadable({
  loader: () => import('views/panels/settings/setup/hierarchy/versions-detail'),
  loading: Loading,
});
ContentHierarchyVersionsDetail.preload();

const ContentHierarchyDraftsDetail = Loadable({
  loader: () => import('views/panels/settings/setup/hierarchy/drafts-detail'),
  loading: Loading,
});
ContentHierarchyDraftsDetail.preload();

const ContentMasterData = Loadable({
  loader: () =>
    import('views/panels/settings/setup/general/content-masterdata'),
  loading: Loading,
});
ContentMasterData.preload();

const ContentMasterDataDetails = Loadable({
  loader: () => import('views/panels/settings/setup/masterdata/details'),
  loading: Loading,
});
ContentMasterDataDetails.preload();

const ContentMasterDataCreate = Loadable({
  loader: () =>
    import('views/panels/settings/setup/masterdata/create-new-type'),
  loading: Loading,
});
ContentMasterDataCreate.preload();

const ContentSettingsHierarchySetup = Loadable({
  loader: () => import('views/panels/settings/setup/hierarchy/setup'),
  loading: Loading,
});
ContentSettingsHierarchySetup.preload();

const SubnavSettings = Loadable({
  loader: () => import('views/panels/subnav-settings'),
  loading: Loading,
});
SubnavSettings.preload();

const ContentDashboard = Loadable({
  loader: () => import('views/panels/dashboards/content-dashboard'),
  loading: Loading,
});

const CreateNewDashboard = Loadable({
  loader: () => import('views/panels/dashboards/modal-new-dashboard'),
  loading: Loading,
});
CreateNewDashboard.preload();

const ContentDashboardDetail = Loadable({
  loader: () => import('views/panels/dashboards/content-dashboard-detail'),
  loading: Loading,
});
ContentDashboardDetail.preload();

const ContentUserProfile = Loadable({
  loader: () => import('views/panels/content-user-profile'),
  loading: Loading,
});
ContentUserProfile.preload();

const ContentClientAccess = Loadable({
  loader: () =>
    import('views/panels/settings/setup/general/content-client-access'),
  loading: Loading,
});
ContentClientAccess.preload();

const ContentUsers = Loadable({
  loader: () => import('views/panels/settings/setup/general/content-users'),
  loading: Loading,
});
ContentUsers.preload();

const ContentRoles = Loadable({
  loader: () => import('views/panels/settings/setup/general/content-roles'),
  loading: Loading,
});
ContentRoles.preload();

const ContentRoleAssignments = Loadable({
  loader: () =>
    import('views/panels/settings/setup/general/content-role-assignments'),
  loading: Loading,
});
ContentRoleAssignments.preload();

const ContentChangeLog = Loadable({
  loader: () =>
    import('views/panels/settings/setup/general/content-change-log'),
  loading: Loading,
});
ContentChangeLog.preload();

const ContentHierarchySetup = Loadable({
  loader: () => import('views/panels/settings/setup/hierarchy/setup'),
  loading: Loading,
});
ContentHierarchySetup.preload();

const ContentHierarchyNew = Loadable({
  loader: () => import('views/panels/settings/setup/hierarchy/new'),
  loading: Loading,
});
ContentHierarchyNew.preload();

const ContentUserDetails = Loadable({
  loader: () => import('views/panels/settings/users/content-user-details'),
  loading: Loading,
});
ContentUserDetails.preload();

const ContentRoleEdit = Loadable({
  loader: () => import('views/panels/settings/roles/content-role-edit'),
  loading: Loading,
});
ContentRoleEdit.preload();

const ContentRoleNew = Loadable({
  loader: () => import('views/panels/settings/roles/content-role-new'),
  loading: Loading,
});
ContentRoleNew.preload();

const ContentAssignmentRuleEdit = Loadable({
  loader: () => import('views/panels/settings/rules/content-rule-edit'),
  loading: Loading,
});
ContentAssignmentRuleEdit.preload();

const ContentAssignmentRuleNew = Loadable({
  loader: () => import('views/panels/settings/rules/content-rule-new'),
  loading: Loading,
});
ContentAssignmentRuleNew.preload();

const ContentSettingsDataConnectors = Loadable({
  loader: () =>
    import(
      'views/panels/settings/integrate/data-connectors/content-settings-data-connectors'
    ),
  loading: Loading,
});
ContentSettingsDataConnectors.preload();

const ContentDataSources = Loadable({
  loader: () =>
    import(
      'views/panels/data-sources/content-data-sources/content-data-sources'
    ),
  loading: Loading,
});
ContentDataSources.preload();

const ContentDataSourceList = Loadable({
  loader: () =>
    import(
      'views/panels/data-sources/content-data-source-list/content-data-source-list'
    ),
  loading: Loading,
});
ContentDataSourceList.preload();

const ContentDataSourceDetail = Loadable({
  loader: () => import('views/panels/data-sources/content-data-source-detail/'),
  loading: Loading,
});
ContentDataSourceDetail.preload();

const FavoriteDataSources = Loadable({
  loader: () =>
    import('views/panels/data-sources/content-data-source-favorites'),
  loading: Loading,
});
FavoriteDataSources.preload();

const ContentDBA = Loadable({
  loader: () => import('views/panels/content-dba'),
  loading: Loading,
});

const ContentDBAReplay = Loadable({
  loader: () => import('views/panels/content-dba-replay'),
  loading: Loading,
});

var Panels = {
  'content-navigation': NavigationPanel,
  'content-dashboards': ContentDashboard,
  'content-auth': ContentAuth,
  'content-error': ContentError,
  'header-site-nav': HeaderSiteNav,
  'header-verintTop': HeaderVerintTop,
  'sidebar-unified': NavUnified,
  'sidebar-project-dnd': SidebarProjectDnd,
  'content-chart-panel': ChartPanel,
  'subnav-dashboards': DashboardFilters,
  'content-dashboard': ContentDashboard,
  'content-dashboard-detail': ContentDashboardDetail,
  'content-new-dashboard': CreateNewDashboard,
  'subnav-settings': SubnavSettings,
  'content-user-profile': ContentUserProfile,

  //
  // Start of Setting Layouts
  //
  // General Setting Layouts
  'content-settings-general-client-access': ContentClientAccess,
  'content-settings-general-users': ContentUsers,
  'content-settings-general-roles': ContentRoles,
  'content-settings-general-role-assignments': ContentRoleAssignments,
  'content-settings-general-change-log': ContentChangeLog,
  // Hierarchy Settings
  'content-settings-hierarchy': ContentHierarchy,
  'content-settings-hierarchy-setup': ContentHierarchySetup,
  'content-settings-hierarchy-new': ContentHierarchyNew,
  'content-settings-hierarchy-details': ContentHierarchyDetails,
  'content-settings-hierarchy-versions-detail': ContentHierarchyVersionsDetail,
  'content-settings-hierarchy-drafts-detail': ContentHierarchyDraftsDetail,
  // Masterdata Settings
  'content-settings-masterdata': ContentMasterData,
  'content-settings-masterdata-details': ContentMasterDataDetails,
  'content-settings-masterdata-create': ContentMasterDataCreate,
  // User Settings
  'content-settings-user-details': ContentUserDetails,
  // Role Settings
  'content-settings-role-edit': ContentRoleEdit,
  'content-settings-role-new': ContentRoleNew,
  // Assignment Rule Settings
  'content-settings-rule-edit': ContentAssignmentRuleEdit,
  'content-settings-rule-new': ContentAssignmentRuleNew,
  // Integration Settings
  'content-settings-data-connectors': ContentSettingsDataConnectors,
  //
  // End of Setting Layouts
  //
  //
  // Start of Analyze Layouts
  //

  // Start of Data Sources
  'content-data-sources': ContentDataSources,
  'content-data-sources-list': ContentDataSourceList,
  'content-data-source-detail': ContentDataSourceDetail,
  'content-data-source-favorites': FavoriteDataSources,
  // End of Data Sources
  // Redirect
  'content-dba': ContentDBA,
  'content-dba-replay': ContentDBAReplay,
  // End of Redirect
};
export default Panels;
